import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Rocket, Users, BadgeCheck, Clock } from "lucide-react";

export default function CreatorChallengesSection({ challenges }) {
  return (
    <div data-testid="creator-challenges-section">
      <h2 className="text-xl sm:text-2xl font-medium text-[#f7f8f8] mb-4">Your 30-Day Challenges</h2>
      {challenges.length === 0 ? (
        <div className="glass-panel rounded-2xl p-8 text-center" data-testid="creator-challenges-empty">
          <Rocket className="w-8 h-8 text-slate-500 mx-auto mb-3" />
          <p className="text-slate-400 text-sm">You haven't generated any AI challenges yet — try the "AI Challenge Builder" quick action above.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {challenges.map((c, i) => (
            <motion.div key={c.id} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}>
              <Link to={c.is_published ? `/custom-challenges/${c.id}` : `/creator/challenges/${c.id}/builder`} data-testid={`creator-challenge-row-${c.id}`}
                className="rounded-xl border border-white/[0.08] bg-[#131a29]/80 backdrop-blur-xl p-4 flex items-center justify-between gap-4 hover:border-white/20 hover:-translate-y-0.5 transition-[transform,border-color] duration-200">
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="font-semibold text-white text-sm">{c.title}</h3>
                    {c.is_published ? (
                      <span className="flex items-center gap-1 text-[10px] font-bold uppercase px-2 py-0.5 rounded-full bg-emerald-400/10 text-emerald-300"><BadgeCheck className="w-3 h-3" /> Published</span>
                    ) : (
                      <span className="flex items-center gap-1 text-[10px] font-bold uppercase px-2 py-0.5 rounded-full bg-slate-400/10 text-slate-400"><Clock className="w-3 h-3" /> Draft</span>
                    )}
                  </div>
                  <p className="text-xs text-slate-500 mt-1 flex items-center gap-1.5"><Users className="w-3 h-3" /> {c.learners_count} learner{c.learners_count === 1 ? "" : "s"} · {c.category}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
